ownStoreObject